import React from "react";
import { HOW_IT_WORKS, STATS } from "../mock";

const HowItWorks = () => {
  return (
    <section id="how" className="py-14 md:py-24 bg-[#0a0f1c]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center text-red-400 text-[11.5px] tracking-[0.22em] uppercase font-medium">
          How it works
        </div>
        <h2 className="mt-3 text-center text-white text-[34px] md:text-[44px] font-semibold leading-[1.1] tracking-tight">
          From application to cashback in{" "}
          <span className="text-amber-400">4 simple steps</span>
        </h2>
        <p className="mt-4 text-center text-slate-300 max-w-2xl mx-auto">
          A proven 23-year-old process — used by 8,000+ students who now study in 5 countries.
        </p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {HOW_IT_WORKS.map((s, idx) => (
            <div
              key={s.n}
              className="relative rounded-2xl cc-card p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="text-[36px] font-bold tracking-tight text-amber-400/90 leading-none">{s.n}</div>
              <div className="mt-3 h-px bg-gradient-to-r from-amber-500/40 to-transparent" />
              <h3 className="mt-5 text-white text-[17px] font-semibold leading-snug">{s.title}</h3>
              <p className="mt-3 text-slate-300 text-[14px] leading-relaxed">{s.desc}</p>
              {idx < 3 && (
                <div className="hidden lg:block absolute top-8 -right-3 w-6 h-px bg-gradient-to-r from-amber-500/30 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Stats bar */}
      <div className="mt-20 border-y border-white/5 bg-[#070b14]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-y-8 gap-x-6">
            {STATS.map((s) => (
              <div key={s.label} className="text-center">
                <div className="text-amber-400 text-[36px] md:text-[44px] font-semibold tracking-tight leading-none">
                  {s.value}
                </div>
                <div className="mt-2 text-slate-400 text-[11.5px] tracking-[0.18em] uppercase">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
